
import { reachGoal } from '../utils/metrika.js';


export default {
    name: 'MeatPageMainBanner',
    props: {
        banner: {
            type: Object,
            required: true,
            default: () => ({})
        },
        common: {
            type: Object,
            required: true,
            default: () => ({})
        },
    },
    computed: {
        certificates() {
            const cert = this.banner?.certificate;
            if (!cert) return [];
            return Array.isArray(cert) ? cert : [cert];
        }
    },
    methods: { reachGoal, getCurrentHalalIcon() {
        if (this.banner.halalType === "kazakhstan") return this.banner.emblem && this.banner.emblem.src ? this.banner.emblem : this.common.halalKazakhstanImage;
        if (this.banner.halalType === "india") return this.banner.emblem && this.banner.emblem.src ? this.banner.emblem : this.common.halalIndiaImage;
        if (this.banner.halalType === "belarus") return this.banner.emblem && this.banner.emblem.src ? this.banner.emblem : this.common.halalBelarusImage;
        return this.banner.emblem && this.banner.emblem.src ? this.banner.emblem : this.common.halalImage;
    } }
}
